<template>
  <div ref="assessmentModal">
    <v-dialog
      v-model="dialogFlag"
      width="500"
    >
      <v-card>
        <v-card-title>
          {{ cardTitle }}
        </v-card-title>

        <v-card-text
          class="body-1"
        >
          <!-- GLA Modal content -->
          <template v-if="option === 'gla'">
            To register for the free GLA certification, visit
            <v-btn
              class="px-0 mt-n1"
              color="primary"
              :style="`
              text-decoration: underline;
              text-transform: lowercase;
              font-size: 16px;
            `"
              text
              small
              @click="openLink(`${glaClientLink}`)"
            >
              {{ glaClientLink }}
            </v-btn>.
            If you purchased professional access to the GLA portal but
            have not received your account access please email
            <a href="mailto:GLA@GlobalCoachGroup.com">GLA@GlobalCoachGroup.com</a>
            for assistance.
          </template>

          <!-- LGPR Modal contents -->
          <template v-else-if="option === 'lgpr'">
            To access this service you must be a Certified Global Leadership Coach.
            <v-btn
              class="px-0 mt-n1"
              color="primary"
              :style="`
              text-decoration: underline;
              text-transform: none;
              font-size: 16px;
            `"
              text
              small
              @click="openLink('https://globalcoachgroup.com/coach-certification/')"
            >
              Click here to find out how to get certified.
            </v-btn>
          </template>

          <template v-else-if="option === 'coaching_tools'">
            To subscribe to use Coaching Tools, visit
            <v-btn
              class="px-0 mt-n1"
              color="primary"
              :style="`
            text-decoration: underline;
            text-transform: unset;
            font-size: ${customRem}px;
            font-weight: normal;
          `"
              text
              small
              @click="openLink('https://globalcoachgroup.com/coaching-tools/')"
            >
              https://globalcoachgroup.com/coaching-tools/.
            </v-btn>
            If you have already subscribed to the Coaching tools but
            haven't received access for your account please email
            <a href="mailto:help@globalcoachgroup.com">
              help@globalcoachgroup.com
            </a>
            for assistance.
            Please include when you purchased and the plan you subscribed too.
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            outlined
            @click="dialogFlag = !dialogFlag"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AssessmentModal',

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    option: {
      type: String,
      default: '',
    },
  },

  computed: {
    dialogFlag: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      },
    },

    cardTitle() {
      let title = '';

      if (this.option === 'gla') {
        title = 'Global Leadership Assessment (GLA 360)';
      } else if (this.option === 'lgpr') {
        title = 'LGPR Survey';
      } else if (this.option === 'coaching_tools') {
        title = 'Coaching Tools';
      }
      return title;
    },

    glaClientLink() {
      // return process.env.VUE_APP_GLA_CLIENT || 'https://gla.gcgroup.io/';
      return 'https://gla-360.com/certification/';
    },

    customRem() {
      return this.$vuetify.breakpoint.mdAndUp ? '17' : '16';
    },
  },

  methods: {
    openLink(link) {
      window.open(link, '_blank');
    },
  },
};
</script>
